import { C } from '../../theme.js';
import { Alert, Code, Eyebrow } from '../../components/Primitives.jsx';
import { CATEGORIES, STEP_TYPES } from '../../data.js';

// ── Generic placeholder (unknown step type fallback) ───────────────────
export function PlaceholderInspector({ step }) {
  const meta = STEP_TYPES[step.type] || {};
  const cat = CATEGORIES[meta.cat] || {};
  return (
    <div>
      <Eyebrow style={{ color: cat.accent || C.accent }}>{cat.label || 'Step'}</Eyebrow>
      <div style={{ color: C.fg1, fontSize: '.95rem', fontWeight: 700, margin: '4px 0 10px' }}>
        {meta.label}
      </div>
      <div style={{ color: C.fg3, fontSize: '.84rem', lineHeight: 1.5, marginBottom: 14 }}>
        {meta.shortDesc}
      </div>
      <Alert kind="info">
        Detailed configuration for this step arrives in <Code>v0.7</Code>.
        Until then it appears in the canvas with default settings and passes
        rows through unchanged in the preview.
      </Alert>
    </div>
  );
}
